import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { apiUrl, authTitle } from '../../../../../../config';
import { FaChartBar, FaList, FaMailBulk, FaPaperPlane, FaUser } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { Form } from '@unform/web';
import Input from 'src/components/Forms/Input';
import { downloaditPost } from 'src/utils/download';


interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule(): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();
  const globalList = async () => {
    addLoading({ title: 'Carregando', key: 'loading' });
    const content = await api.get('invitation-confirmation', { params: { limitItems: 100000 } });

    const items = [['CATEGORIA VIP', 'CONFIRMADO?', 'MESA', 'NOME', 'E-MAIL', 'CPF', 'EMPRESA', 'CARGO', 'CATEGORIA']];

    const autoridades = content?.data?.rows?.filter(i => i?.vip_category === 'AUTORIDADE' && i?.confirmated === 'Sim')?.sort((a, b) => a?.name < b?.name ? -1 : a?.name > b?.name ? 1 : 0);
    const patrocinadores = content?.data?.rows?.filter(i => i?.vip_category === 'PATROCINADOR' && i?.confirmated === 'Sim')?.sort((a, b) => a?.changed_by < b?.changed_by ? -1 : a?.changed_by > b?.changed_by ? 1 : 0)
    const all = content?.data?.rows?.filter(i => i?.vip_category !== 'PATROCINADOR' && i?.vip_category !== 'AUTORIDADE' && i?.confirmated === 'Sim')?.sort((a, b) => a?.changed_by < b?.changed_by ? -1 : a?.changed_by > b?.changed_by ? 1 : 0)

    autoridades?.map(a => {

      items.push([
        a?.vip_category,
        a?.confirmated,
        a?.table,
        a?.name,
        a?.email,
        a?.document_number,
        a?.company,
        a?.position,
        a?.category_id


      ])


    })

    patrocinadores?.map(a => {

      items.push([
        a?.vip_category,
        a?.confirmated,
        a?.table,
        a?.changed_by,
        a?.email,
        a?.document_number,
        a?.company,
        a?.position,
        a?.category_id


      ])


    })


    all?.map(a => {
      items.push([
        a?.vip_category,
        a?.confirmated,
        a?.table,
        a?.name,
        a?.email,
        a?.document_number,
        a?.company,
        a?.position,
        a?.category_id


      ])

    })

    downloaditPost({ url: `${apiUrl}/converter/xlsx`, data: items, type: 'xlsx' });
    removeLoading('loading');
    return
  }

  const ChangeUser = async () => {
    addLoading({ title: 'Carregando', key: 'loading' });
    const content = await api.get('invitation-confirmation', { params: { limitItems: 100000 } });

    const items = [['CATEGORIA VIP', 'CONFIRMADO?', 'MESA', 'NOME', 'E-MAIL', 'CPF', 'EMPRESA', 'CARGO', 'CATEGORIA']];

    const autoridades = content?.data?.rows?.filter(i => i?.vip_category === 'AUTORIDADE' && i?.confirmated === 'Sim')?.sort((a, b) => a?.name < b?.name ? -1 : a?.name > b?.name ? 1 : 0);
    const patrocinadores = content?.data?.rows?.filter(i => i?.vip_category === 'PATROCINADOR' && i?.confirmated === 'Sim')?.sort((a, b) => a?.changed_by < b?.changed_by ? -1 : a?.changed_by > b?.changed_by ? 1 : 0)

    autoridades?.map(a => {

      items.push([
        a?.vip_category,
        a?.confirmated,
        a?.table,
        a?.name,
        a?.email,
        a?.document_number,
        a?.company,
        a?.position,
        a?.category


      ])


    })

    patrocinadores?.map(a => {

      items.push([
        a?.vip_category,
        a?.confirmated,
        a?.table,
        a?.changed_by,
        a?.email,
        a?.document_number,
        a?.company,
        a?.position,
        a?.category


      ])


    })


    downloaditPost({ url: `${apiUrl}/converter/xlsx`, data: items, type: 'xlsx' });
    removeLoading('loading');
    return
  }



  const moduleUpdate = (): JSX.Element => (<>
    <button className='searchButton' title='Download de Patrocinadores e Autoridades confirmados' onClick={() => { ChangeUser() }}><FaList /></button>
    <button className='searchButton' title='Download de todos os Confirmados' onClick={() => { globalList() }}><FaList color='yellow' /></button>
  </>
  );

  return moduleUpdate();
}
